import { Validators, UntypedFormGroup } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
// import { loanLeft } from 'src/app/model/appclass';

@Component({
  selector: 'app-farmerreport',
  templateUrl: './farmerreport.component.html',
  styleUrls: ['./farmerreport.component.css']
})
export class FarmerreportComponent implements OnInit, OnDestroy {

  yearid: string = "";
  yearTh: string = "";
  yearidLb: string = "";
  yearLblast: string = "";
  isLoading = false;
  summarycaneFm: any = [];

  constructor(private spinner: NgxSpinnerService) { }

  ngOnInit(): void { }

  listYear = [
    /* ['2223', '6566', '2565/2566', '6465'],
     ['2324', '6667', '2566/2567', '6566'],*/
    ['2425', '6768', '2567/2568', '6667'],
    ['2526', '6869', '2568/2569', '6768'],
    ['2627', '6970', '2569/2570', '6869'],
  ];

  fmcode = '';
  sYear = [];
  selectYear() {
    let ar = this.sYear;
    this.yearid = ar[0];
    this.yearidLb = ar[1];
    this.yearTh = ar[2];
    this.yearLblast = ar[3];
    //console.log('sYear:', this.sYear);
  }

  loading: boolean[] = [false, false, false, false];
  params_like1 = {
    search: '', pageSize: 15, col_like_n: []
  };
  hurl = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/';

  /**
   * ใช้สำหรับรวมค่า property ที่ระบุจากอาร์เรย์ของ object
   * @param data - อาร์เรย์ของ object
   * @param propertyName - ชื่อ property ที่ต้องการรวม
   * @returns ผลรวมของ property ที่ระบุ
   */
  sumByProperty(data: any[], propertyName: string): number {
    if (!data || data.length === 0) return 0;
    return data.reduce((total: number, item: any) => total + (item[propertyName] || 0), 0);
  }

  /**
   * ใช้สำหรับรวมค่าหลาย property จาก object เดียวกัน
   * @param data - อาร์เรย์ของ object
   * @param propertyMappings - object ที่มี key เป็นชื่อ property ต้องการและ value เป็นชื่อ property ในข้อมูล
   * @returns object ที่มีผลรวมของแต่ละ property
   */
  sumMultipleProperties(data: any[], propertyMappings: { [key: string]: string }): { [key: string]: number } {
    const result: { [key: string]: number } = {};
    Object.keys(propertyMappings).forEach(resultKey => {
      result[resultKey] = this.sumByProperty(data, propertyMappings[resultKey]);
    });
    return result;
  }

  async selectSQL(loading_id: number, sql: string): Promise<any> {
    this.loading[loading_id] = true;
    try {
      const res: any = await axios.get(sql);
      this.loading[loading_id] = false;
      const data = res.data;
      return data;
    } catch (err) {
      this.loading[loading_id] = false;
      throw err;
    }
  }

  data_list: any[] = [];
  LoadDataLike1() {
    let search = this.params_like1.search.trim();

    let url = `${this.hurl}function-3/datatable_w`; // เปลี่ยนเป็น URL ของ Cloud Function
    const params = {
      table: `dbo.v_farmer_basic`,
      column: '[fmcode_b1],[fmcode],[fmname],[SUPZONE],[farmer_id]',
      col_like: 'fmcode_b1,fmname',
      length: 15,
      search: search,
      orderColumn: 1,
    };
    if (search.length > 0) {
      this.loading[0] = true;
      axios.get(url, { params })
        .then(res => {
          const data = res.data;
          this.loading[0] = false;
          this.data_list = data.data;
          //console.log('farmer_list:', data);
        }).catch(err => { throw err })
    }
    else {
      this.data_list = [];
    }
  }

  // ข้อมูลคิวชาวไร่
  fm_data: any = {};
  text_fm: string;
  fmname = ''

  async selectOption(list: any, num: number) {
    this.fm_data = list;
    const date = new Date();
    this.params_like1.search = `[${list.fmcode}]:${list.fmname}, โซน:${list.SUPZONE}`;
    this.data_list = [];
    //console.log('Select option:list', list);
    this.farmer_id = list.farmer_id;
    this.fmcode = list.fmcode_b1;
    this.fmname = list.fmname;
    this.Finddata()
    /*await this.Loadfarmerplant();
    await this.LoadDataPlantbyfamer()
    */
  }

  farmerplantlist: any[] = [];

  // ค้นหาข้อมูล
  submited = false;

  /**
   * Get farmer history by year key (e.g., '6061', '6162')
   */
  getFarmerHistoryByYear(farmerItem: any, yearKey: string) {
    // Extract year from yearKey (e.g., '6768' -> '67')
    const yearForLookup = yearKey.substring(0, 2);

    // Find loan data from longdebt array
    const loanRecord = this.longdebt.find(item => item.year === yearForLookup);
    const loanAmount = loanRecord ? loanRecord.balance : 0;

    return {
      yearLabel: `${yearKey.substring(0, 2)}/${yearKey.substring(2, 4)}`,
      area: farmerItem[`area${yearKey}`],
      AS: farmerItem[`AS${yearKey}`],
      wgt: farmerItem[`wgt${yearKey}`],
      ccs: farmerItem[`ccs${yearKey}`],
      yield: farmerItem[`yield${yearKey}`],
      loan: loanAmount || 0,
      yearKey: yearKey
    };
  }

  /**
   * Get all available year history for current farmer
   */
  getAvailableYears(farmerItem: any): any[] {
    if (!farmerItem) return [];
    const years = ['6061', '6162', '6263', '6364', '6465', '6566', '6667'];
    if (this.yearidLb >= '6768') years.push('6768');
    if (this.yearidLb >= '6869') years.push('6869');
    if (this.yearidLb >= '6970') years.push('6970');

    return years
      .map(y => this.getFarmerHistoryByYear(farmerItem, y))
      .filter(item => item !== null);
  }

  /**
   * Get collateral items from contract person
   */
  getCollateralItems(contractPerson: any): any[] {
    const items: any[] = [];
    for (let i = 1; i <= 12; i++) {
      const typeKey = `Type${i}`;
      const type = contractPerson[typeKey];
      if (type && type.length > 1) {
        items.push({
          type: type,
          qty: contractPerson[`Qty${i}`],
          pronoun: contractPerson[`Pronoun${i}`],
          price: contractPerson[`Price${i}`],
          dateAS: contractPerson[`DateASType${i}`],
          dateEnd: contractPerson[`DateEndType${i}`],
          index: i
        });
      }
    }
    return items;
  }

  async Finddata() {
    const data = this.fm_data;
    if (!this.yearid) {
      this.submited = false;
      alert(" !! กรอกเลือกปี !!");
    }
    else if (data.length == 0) {
      this.submited = false;
      alert(" !! กรอกรหัสชาวไร่ !!");
    }
    else {
      this.submited = true;
      await this.LoadFarmerdata();
      await this.LoadAskforproduct();
      await this.LoadDetailplant();
      await this.LoadPlantdata();
      await this.LoadDetailplantX()
      //this.LoadDebtDatail();
      await this.LoadfertilizerDebt();
      //this.loantdata();
      //this.LoadLongDebt();
      await this.LoadTKSDebt();
      await this.LoadContact();
      await this.LoanDatailNow();
      /*
      */
    }
  }

  // โหลดข้อมูลส่วนบุคคลชาวไร่ ประวัติการส่งอ้อย + ข้อมูลชาวไร่ ,หนี้ค้างแต่ละปี
  farmerdata: any[] = [];
  LoanlefData: any[] = [];
  longdebt: any[] = [];
  farmer_id = 0;
  loanData: Array<{ loan6364: 0, loan6465: 0, loan6566: 0, loan6667: 0 }> = [];
  async LoadFarmerdata() {
    let fmcode = this.fmcode;
    let url = this.hurl + "dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_farmer_basic]&w=fmcode_b1='" + fmcode + "'";
    // let url3 = this.hurl + "dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_loanFarmer]&w=[fmcode_b1]='" + fmcode + "'";
    let url4 = this.hurl + "dbbrr/sum_DOCLIST2_fmcode?cardcode=" + fmcode;

    this.farmerdata = await this.selectSQL(1, url);
    let data = await this.selectSQL(1, url4);
    data = data.map((item: any) => {
      return {
        ...item, year_n: `${item.year}/${(parseInt(item.year, 10) + 1)}`,
      };
    });
    console.log('sum_DOCLIST2_fmcode:', data);
    this.longdebt = data;
    //this.longdebt    
  }

  // โหลดข้อมูลแปลงอ้อย
  plantdata: any[] = [];
  plantdataS: any[] = [];
  async LoadPlantdata() {
    let farmer_id = this.farmer_id;
    const url = `${this.hurl}function-2/sum_canetype_YEAR_w?YEAR=${this.yearidLb}&farmer_id=${farmer_id}`;
    let data = await this.selectSQL(1, url);
    if (data.length > 0) {
      this.plantdata = data.filter((el: { YEAR: string; }) => el.YEAR != 'sum');
      this.plantdataS = data.filter((el: { YEAR: string; }) => el.YEAR == 'sum');
    }
    else {
      this.plantdata = [];
      this.plantdataS = [];
    }
  }

  // รายละเอียดแปลงอ้อย
  plantdetail: any[] = [];
  sumcredit_amount: any[] = [];
  sumton: any;
  sumlandvalue = 0;
  sumlandvalue2 = 0;

  sumland = { landvalue1: 0, landvalue2: 0, Assess: 0, Assess_left: 0, sumcredit_amount: 0, loss_amt_2: 0, loss_amt_3: 0 }
  // plotinfo:string = "";
  async LoadDetailplant() {
    let fmcode = this.fmcode
    // axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_cp6566_basic_aw?fmcode=%27"+fmcode+"%27")
    //axios.get("https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0w?t='v_cp_data_YEAR=" + this.yearid + "&fmcode=" + fmcode)
    const url = `${this.hurl}dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp${this.yearidLb}_basic]&w=[farmer_id]=${this.farmer_id}`;
    let data = await this.selectSQL(1, url);
    if (data.length > 0) {
      data = data.sort((a: { intlandno: string; }, b: { intlandno: any; }) => a.intlandno.localeCompare(b.intlandno));
      this.plantdetail = data;
      let sumland = this.sumland;
      /*sumland.sumcredit_amount = (data.map(el => { return el.credit_amount }));
      sumland.Assess_left = (data.map(el => { return el.Assess_left }));*/

      // ใช้ sumMultipleProperties ในการรวมค่า properties หลายตัวพร้อมกัน
      const sums = this.sumMultipleProperties(data, {
        sumcredit_amount: 'credit_amount',
        Assess: 'Assess',
        Assess_left: 'Assess_left',
        landvalue1: 'landvalue',
        landvalue2: 'landvalue_left',
        loss_amt_2: 'causes_of_crop_loss_amt_2',
        loss_amt_3: 'causes_of_crop_loss_amt_3'
      });
      Object.assign(sumland, sums);

      //const reducer = (previousValue, currentValue) => previousValue + currentValue;
      //this.sumcredit_amount = (this.sumcredit_amount.reduce(reducer));
      //this.sumton = (this.sumton.reduce(reducer));
      // this.plotinfo = `Z.${this.plantdetail.supzone} R.${this.plantdetail.route} `;
    }
    else this.plantdetail = [];
  }

  plantdetailX: any[] = [];
  plantdetailX_0: any[] = [];

  async LoadDetailplantX() {
    let farmer_id = this.farmer_id
    let url = `${this.hurl}dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp_data_0]&w=CaneYearName='${this.yearid}'and[farmer_id]=${farmer_id} order by [intlandno]asc`;
    //let url=`${this.hurl}dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_cp_data_0_basic]&w=[year]='${this.yearid}'and[fmcode]='${farmer_id}'`;

    let data = await this.selectSQL(1, url);
    //console.log('LoadDetailplantX:', data);
    //data = data.sort((a: { intlandno: string; }, b: { intlandno: any; }) => a.intlandno.localeCompare(b.intlandno));
    this.plantdetailX = data.filter((el: { ckSts: string; }) => el.ckSts == '1');
    this.plantdetailX_0 = data.filter((el: { ckSts: string; }) => el.ckSts == '0');
    //console.log('plantdetailX:', this.plantdetailX);
    //console.log('plantdetailX_0:', this.plantdetailX_0);
  }

  //  การเบิกปัจจัยการผลิต.
  askforproduct: any[] = [];
  sumgetfactor: number[] = [];
  async LoadAskforproduct() {
    let fmcode = this.fmcode
    let url = `${this.hurl}dbbrr/VW_DOCLIST2DETAIL_year_w?year=` + this.yearidLb.substring(0, 2) + "&cardcode=" + fmcode
    const data = await this.selectSQL(1, url);
    if (data.length > 0) {
      this.askforproduct = data;
      const sums = this.sumMultipleProperties(data, {
        sum: 'linetotalafvat',
      });
      Object.assign(this.sumgetfactor, sums);
      console.log('data getfactor sumget: ', sums, this.askforproduct);
    }
    else this.askforproduct = [];
    //this.sumgetfactor.sum=0
  };

  // สัญญาค้ำประกัน
  contractdata: any;
  contractperson: any;
  onesum: any[] = [];
  async LoadContact() {
    // this.spinner.show();
    let fmcode = this.fmcode
    // บุคคลค้ำ และ หลักทรัพย์
    // let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/promise6566_faw?fmcode_b1=%27"+fmcode+"%27";
    let url = `${this.hurl}dbbrr/promise_fw?year=` + this.yearidLb + "&FMCODE_B1=" + fmcode;
    // ชร. ไปค้ำใครบ้าง
    //let url2 = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/promise6566_fw?fmcode_b1=%27"+fmcode+"%27";
    let url2 = `${this.hurl}dbbrr/promise_faw?year=` + this.yearidLb + "&FMCODE_B1=" + fmcode;
    const data1 = await this.selectSQL(1, url);
    if (data1.recordset.length > 0) {
      this.contractperson = data1.recordset;
    }
    else this.contractperson = [];

    const data2 = await this.selectSQL(1, url2);
    if (data2.recordset.length > 0) {
      this.contractdata = data2.recordset;
    }
    else this.contractdata = [];
  };

  // หนี้ค้างและหนี้แต่ละประเภท
  loanleftdata: any;
  async loantdata() {
    let fmcode = this.fmcode
    let url = `${this.hurl}dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_loanFarmer` + this.yearidLb + `]&w=FMCODE_b1='` + fmcode + `'`;
    const data = await this.selectSQL(1, url);
    //console.log('loanleftdata : ', data);
    if (data.length > 0) {
      this.loanleftdata = data;
    }
    else this.loanleftdata = [];

  }


  // รายละเอียดหนี้
  LoanDatailData: { [key: string]: any[] } = {};
  LoanDatailKeys: string[] = [];
  listLoanNow: any;
  listLoanyear: string[] = [];
  async LoanDatailNow() {
    let fmcode = this.fmcode
    const url = `${this.hurl}dbbrr/VW_DOCLIST2_fmcode_w?cardcode=` + fmcode;
    const data = await this.selectSQL(1, url);
    if (data.length > 0) {
      this.listLoanNow = data;
      let groupedData: { [key: string]: any[] } = {};
      //this.listLoanyear = data.filter(el => el.year == this.yearTh.substring(0, 2));
      data.forEach((entry: { year: any; }) => {
        const year = entry.year;
        if (!groupedData[year]) {
          groupedData[year] = [];
        }
        groupedData[year].push(entry);
      });
      this.LoanDatailData = groupedData;
      this.LoanDatailKeys = Object.keys(groupedData);
    }
    else this.listLoanNow = [];
  }

  calculateTotal(entries: any[]): number {
    if (!entries) { return 0 }
    return entries.reduce((total, entry) => total + entry.balance, 0);
  }

  setnY(key: string): string {
    if (!key) { return '' }
    return `${key}/${Number(key) + 1}`;
  }

  // หนี้ธกส.
  tksdebt: any;
  async LoadTKSDebt() {
    let fmcode = this.fmcode
    const res = await axios.get(`${this.hurl}dbcps/paytks_w?fmcode_b1=%27` + fmcode + `%27`);
    let data = res.data.recordset;
    if (data.length > 0) {
      this.tksdebt = data;
    }
    else this.tksdebt = [];
  }

  // หนี้ปุ๋ยเทกอง 
  fertidebt: any;
  async LoadfertilizerDebt() {
    let fmcode = this.fmcode
    // let url ="https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_cash_get2?fmcode="+fmcode;
    let url = `${this.hurl}dbcps/select_cash_get2_w?yearid=` + this.yearidLb + "&fmcode=" + fmcode;
    const res = await axios.get(url);
    let data = res.data.recordset;
    if (data.length > 0) {
      this.fertidebt = data;
    }
    else this.fertidebt = [];
  }
  THtoLocalstring(thisdate: any) {
    const date1 = new Date(thisdate);
    let options: any = {
      year: "numeric",
      month: "short",
      day: "numeric",
      /*hour: "2-digit",
      minute  : "2-digit", 
      second  : "2-digit",*/
      timeZone: 'UTC'
    };

    return date1.toLocaleString('th-TH', options);
  }
  print() {
    window.print();
  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.fertidebt = null;
    this.farmerdata = [];
    this.tksdebt = null;
    this.plantdata = [];
    this.plantdetail = [];
    this.sumcredit_amount = [];
    this.sumton = null;
    this.sumlandvalue = 0;
    this.askforproduct = [];
    this.contractdata = null;
    this.contractperson = null;
    this.onesum = [];
    this.loanData = [];
    this.loanleftdata = null;

  }
}
